export default {
  title: 'Informação Pessoal',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    personal_info_updated_successfully: 'Informação guardada com sucesso',
  },
};
